import { ADD_FOLDER, FOLDER_DELETE, FOLDER_EDIT, FOLDER_LIST, FOLDER_VIEW } from "./types";


export const folderListAction = (data, onSuccess, onError) => {
    return {
        type: FOLDER_LIST,
        data,
        onSuccess,
        onError,
    };
};
export const addfolderAction = (data, onSuccess, onError) => {
    return {
        type: ADD_FOLDER,
        data,
        onSuccess,
        onError
    }
};

export const folderEdit = (data, onSuccess, onError) => {
    return {
        type: FOLDER_EDIT,
        data,
        onSuccess,
        onError,
    };
};


export const folderDelete = (data, onSuccess, onError) => {
    return {
        type: FOLDER_DELETE,
        data,
        onSuccess,
        onError,
    };
};

export const folderView = (data, onSuccess, onError) => {
    return {
        type: FOLDER_VIEW,
        data,
        onSuccess,
        onError,
    };
};